export const camelToTitleCase = (camelCase: string) =>
  camelCase
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase());

export const toSentenceCase = (sentence: string) =>
  sentence.charAt(0).toUpperCase() + sentence.slice(1);

export const formatPhoneNumber = (phone: string | undefined) => {
  if (!phone) return phone;

  switch (phone?.length) {
    case 12:
      return `${phone?.slice(0, 3)} ${phone?.slice(3, 6)} ${phone?.slice(6, 9)} ${phone?.slice(9, 12)}`;
    case 10:
      return `${phone?.slice(0, 4)} ${phone?.slice(4, 7)} ${phone?.slice(7, 10)}`;
    case 8:
      return `${phone?.slice(0, 4)} ${phone?.slice(4, 8)}`;
    default:
      return phone;
  }
};

export const numberToCharacter = (n: number): string => {
  if (n <= 0 || n > 26) {
    return 'None';
  }
  return String.fromCharCode(64 + n); // 64 + 1 = 65 (A), 64 + 2 = 66 (B), etc.
};

export const joinNames = (names: (string | number | undefined)[]) => names.filter((x) => x).join(' ');
